import styled from 'styled-components';

export const IndicatorContainer = styled.div`
  margin-top: 5px;
  width: 100%;
  display: flex;
  flex-flow: column;
  
  span {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
`;

export const Indicator = styled.div`
  width: 100%;
  display: flex;
  border-radius: 5px;
  border: 1px solid lightgray;
`;

export const Bar = styled.div`
  background: ${props => props.color};
  width: 19.5%;
  margin: 0.25%;
  height: 5px;
  
  border-radius: ${props => props.index === 0 ? 
          "5px 0 0 5px" : props.index === 4 ? "0 5px 5px 0" : "0"};
`;

export const Requirements = styled.div`
  width: 100%;
  height: auto;
`;

export const Requirement = styled.p`
  font-size: 16px;
  margin: 2.5px 0;
  color: ${props => props.valid ? "green" : "red"};
`;